import { imageServerRoot } from '../consts';
import { getImageServerBaseUrlForImage } from 'lbs-pi-platform-access/src/system/utils';

export class ImageServerHelper {
  _imageServers;

  // Support for hub/spoke. Images can be hosted on different servers, so, try to associate the image with the server
  // it's hosted on. If the image is just an id or path we obviously can't do this so we just assume 'imageServer/' as
  // the base url.
  getImageInfo (image) {
    const info = {
      baseUrl: imageServerRoot,
      imageIdOrPath: ''
    };

    if (typeof image === 'string' || typeof image === 'number') {
      info.imageIdOrPath = image;
    } else {
      info.imageIdOrPath = image.imageId;
      if (this._imageServers) {
        info.baseUrl = getImageServerBaseUrlForImage(this._imageServers, image);
      }
    }
    return info;
  }

  configureImageServers (servers) {
    this._imageServers = servers;
  }
}
